import { useNavigate } from "react-router-dom";
import {
  formateDateToJalali,
  typePersianConverter,
} from "../../../utils/Functions";
import Table from "../../common/table";

const TestList = ({ data, count = 10 }: any) => {
  const navigate = useNavigate();

  const TdComponent = ({ children }: any) => {
    return <td className="whitespace-nowrap text-sm">{children}</td>;
  };

  return (
    <div>
      <div className="overflow-x-auto">
        <Table
          header={[
            "",
            "ایجاد کننده",
            "تاریخ ثبت آزمایش",
            "نوع آزمایش",
            "تعداد فایل‌ها",
          ]}
          body={data.results
            ?.slice(0, count)
            .map((result: any, idx: number) => (
              <tr
                className="cursor-pointer hover duration-300 border-gray-100"
                key={idx}
                onClick={() =>
                  navigate(
                    `/dashboard-records/${result.creator_id}/${result.id}`
                  )
                }
              >
                <TdComponent>{idx + 1}</TdComponent>
                <TdComponent>
                  {result.creator}{" "}
                  {result.is_for_other && (
                    <span className="bg-pr_green px-2 rounded text-xs font-[700] font-rokh pt-1">
                      برای دیگری
                    </span>
                  )}
                </TdComponent>
                <TdComponent>
                  {formateDateToJalali(result.created_at)}
                </TdComponent>
                <TdComponent>{typePersianConverter(result.type)}</TdComponent>
                <TdComponent>{result.files_count}</TdComponent>
              </tr>
            ))}
        />
      </div>
    </div>
  );
};

export default TestList;
